import { render, staticRenderFns } from "./UiChartLegend.vue?vue&type=template&id=a07e90e4&functional=true&"
import script from "./UiChartLegend.vue?vue&type=script&lang=js&"
export * from "./UiChartLegend.vue?vue&type=script&lang=js&"
import style0 from "./UiChartLegend.vue?vue&type=style&index=0&id=a07e90e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports